import { render, staticRenderFns } from "./chatRemind.vue?vue&type=template&id=12ecc36a&"
import script from "./chatRemind.vue?vue&type=script&lang=js&"
export * from "./chatRemind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports